
document.addEventListener('DOMContentLoaded', function () {
  let loading = false;
  let observer = null;

  const loadedPages = new Set();
  const loadedProducts = new Set();

  function getProductKey(product) {
    const link = product.querySelector(
      'a[href*="/products/"]'
    );

    if (!link) return null;

    const url = new URL(link.href, window.location.origin);

    // Ignore query strings and variants so the same product
    // cannot be appended twice.
    return url.pathname.replace(/\/$/, '');
  }

  function rememberExistingProducts(grid) {
    grid.querySelectorAll(':scope > .grid__item').forEach(function (item) {
      const key = getProductKey(item);
      if (key) loadedProducts.add(key);
    });
  }

  function stopInfiniteScroll(sentinel) {
    if (observer) observer.disconnect();
    if (sentinel) sentinel.remove();
    loading = false;
  }

  function initInfiniteScroll() {
    const sentinel = document.querySelector('#atha-infinite-scroll');
    const grid = document.querySelector('#product-grid');

    if (!sentinel || !grid) return;

    const nextButton = sentinel.querySelector('.atha-infinite-next');
    if (!nextButton) {
      stopInfiniteScroll(sentinel);
      return;
    }

    if (sentinel.dataset.initialized === 'true') return;
    sentinel.dataset.initialized = 'true';

    rememberExistingProducts(grid);

    observer = new IntersectionObserver(async function (entries) {
      if (!entries.some(function (entry) {
        return entry.isIntersecting;
      })) return;

      if (loading) return;

      const url = nextButton.href;
      if (!url) {
        stopInfiniteScroll(sentinel);
        return;
      }

      // Prevent requesting the same pagination URL repeatedly.
      if (loadedPages.has(url)) {
        stopInfiniteScroll(sentinel);
        return;
      }

      loading = true;
      loadedPages.add(url);

      try {
        const response = await fetch(url, {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Could not load the next collection page.');
        }

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const nextGrid = parsed.querySelector('#product-grid');
        const newProducts = nextGrid
          ? nextGrid.querySelectorAll(':scope > .grid__item')
          : [];

        let addedCount = 0;

        newProducts.forEach(function (product) {
          const key = getProductKey(product);

          if (key && loadedProducts.has(key)) return;

          if (key) loadedProducts.add(key);

          grid.appendChild(product);
          addedCount++;
        });

        const nextPageLink = parsed.querySelector(
          '#atha-infinite-scroll .atha-infinite-next'
        );

        if (!nextPageLink || !nextPageLink.href) {
          stopInfiniteScroll(sentinel);
          return;
        }

        const nextUrl = nextPageLink.href;

        // Stop if Shopify returns the same page again.
        if (loadedPages.has(nextUrl) || nextUrl === url) {
          stopInfiniteScroll(sentinel);
          return;
        }

        // If a page contains only duplicates, stop instead of
        // continuously fetching the same products.
        if (addedCount === 0) {
          stopInfiniteScroll(sentinel);
          return;
        }

        nextButton.href = nextUrl;
        loading = false;

      } catch (error) {
        console.error('Atha Infinite Scroll:', error);
        loadedPages.delete(url);
        loading = false;
      }

    }, {
      rootMargin: '800px 0px'
    });

    observer.observe(sentinel);
  }

  initInfiniteScroll();

  // Reinitialize if Shopify replaces collection markup after filtering.
  const pageObserver = new MutationObserver(function () {
    const sentinel = document.querySelector('#atha-infinite-scroll');

    if (sentinel && sentinel.dataset.initialized !== 'true') {
      initInfiniteScroll();
    }
  });

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
